module.exports = __webpack_public_path__ + "media/mypage/images/icons/credit-cards/diners-e103672c4adeb8d13ca13f3498e6cc83.png";